import useMakesStore from 'Stores/MakesStore/MakesStore';
import useModelsStore from 'Stores/ModelsStore/ModelsStore';

const useGetSelectedModelsAndMakesHandler = (callback) => {
	const getMakesBySlugs = useMakesStore((store) => store.getMakesBySlugs);
	const getModelsById = useModelsStore((store) => store.getModelsById);

	const handler = (makesAndModels) => {
		const [make, model] = makesAndModels;
		const selectedMakes = getMakesBySlugs(make);
		const selectedModels = getModelsById(model);
		return callback(selectedMakes, selectedModels);
	};

	return handler;
};

export default useGetSelectedModelsAndMakesHandler;
